export default __webpack_public_path__ + "static/1064-0453f690d3bdc89c11e764cc0715bb02.gif";